// extracted by mini-css-extract-plugin
export default {"icon":"nyZ3f7LL","wrapper":"p7t5A3a4","submit":"G0j_EJsN","button":"kecvxvy0","label":"U2ROjoe4"};